import { combineReducers } from 'redux'

import menu from './menu'
import widgets from './widgets'

const canUseNewHeaderAndSidebar = (state = false) => state

export default combineReducers({
  menu,
  widgets,
  canUseNewHeaderAndSidebar,
})
